import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { isMobile, isMobileLandscape } from 'react-device-detect';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import TournamentPlayerList from './TournamentPlayerList';
import TournamentRegisterResumeButton from '../TournamentRegisterResumeButton';
import { getTournamentPlayers } from '../../../../../../../../store/selectors';
import { renderStatBlockMobile } from '../helpers/renderStat';
import { renderPrizePool } from '../helpers/renderPrizePool';
import { playersAwardsFiltering } from '../helpers/playerAwardsFiltering';
import { getTournamentBuyinInfo } from '../helpers/getTournamentBuyinInfo';
import '../../../../../../../../assets/stylesheets/TournamentCasino/TournamentCasinoRow.scss';


const classesBasedOnButtonStatus = {
  register: 'tournaments__lobby__header--mobile__button tournaments__lobby__header--mobile__button--register',
  finish_lateReg_closed: 'tournaments__lobby__header--mobile__button tournaments__lobby__header--mobile__button--finish-closed',
  unregister: 'tournaments__lobby__header--mobile__button tournaments__lobby__header--mobile__button--unregister',
  resume_rebuy: 'tournaments__lobby__header--mobile__button tournaments__lobby__header--mobile__button--resume-rebuy'
}


const TournamentLobby = ({
  data,
  onClose,
  onResume,
  onRegister,
  onRefresh,
  onUnregister,
  onChat,
  emitToSocket,
  isGameOpened,
  closeGameAndBackToLobby,
  showLobbyFromGame,
  onGameFromLobby,
}) => {

  const { t } = useTranslation();
  const [showMorePrizesMobile, setShowMorePrizesMobile] = useState(false);
  const [showMoreStatsMobile, setshowMoreStatsMobile] = useState(false);
  const [showMorePlayersMobile, setShowMorePlayersMobile] = useState(false);
  const { chipValue } = getTournamentBuyinInfo(data);

  const tournamentCasinoPlayersList = useSelector(getTournamentPlayers)[data.tournamentId] || [];

  const playerAwardsStructure = playersAwardsFiltering(data);

  const tornamentLobbyClasses = classNames({
    'tournaments__popup': true,
    'tournaments__lobby': true,
    'tournaments__lobby--mobile': true,
    'lobby-from-game': showLobbyFromGame,
  })

  return (
    <div className={tornamentLobbyClasses}>
      <div className="tournaments__lobby__overlay tournaments__popup__overlay" onClick={onClose} />
      <div className="tournaments__lobby__window">
        <React.Fragment>
          <div className="tournaments__lobby__top-row">
            <span onClick={onClose} className='tournaments__lobby__top-row-icon'>
              <FontAwesomeIcon icon={faChevronLeft} color="white" className="fa chevron-left"></FontAwesomeIcon>
            </span>
            <span className='tournaments__lobby__top-row-title'>{t('club.text')}</span>
          </div>
          <header className="tournaments__lobby__header--mobile">
            {!isMobileLandscape &&
              <div className="tournaments__lobby__header--mobile__img-wrapper">
                <img src={`${data.tournamentGames[0]['thumbnail']}`} alt={`${data.tournamentName}`} />
              </div>
            }
            <div className="tournaments__lobby__header--mobile__buttons-wrapper">
              {isMobileLandscape &&
                <span className="tournaments__lobby__header--title">{data.tournamentName}</span>
              }
              <div className="tournaments__lobby__header--mobile__buttons-container">
                <button onClick={onClose} className="tournaments__lobby__header--mobile__button secondary">{t('tournaments.backТoMainLobby')}</button>
                <TournamentRegisterResumeButton
                  tournament={data}
                  onResume={isGameOpened ? onClose : onResume}
                  onRegister={onRegister}
                  short
                  buttonClassnames={classesBasedOnButtonStatus}
                  onGameFromLobby={onGameFromLobby}
                  showLobbyFromGame={showLobbyFromGame}
                  btnClassesNames={{ primary: 'primary' }}
                  onUnregister={onUnregister}
                  isLobby
                />
              </div>
            </div>
          </header>
          <div className="tournaments__lobby__stats-container-wrapper">
            <div className="tournaments__lobby__stats-button-wrapper--mobile">
              <div className="tournaments__lobby__stats--mobile">
                {renderStatBlockMobile(data, isMobileLandscape || showMoreStatsMobile, t)}
              </div>
              {!isMobileLandscape &&
                <div className="tournaments__lobby__button-prize-wrapper--mobile">
                  <button className='tournaments__lobby__stats-prize-button--mobile tertiary' onClick={() => setshowMoreStatsMobile(show => !show)}>
                    <span>{showMoreStatsMobile ? `${t('tournaments.seeLess')}` : `${t('tournaments.seeMore')}`}</span>
                  </button>
                </div>
              }
            </div>
            {(!isMobileLandscape ? playersAwardsFiltering(data).length > 0 : true) && <div className='tournaments__lobby__more-prizes--mobile'>
              {isMobileLandscape && !showMorePrizesMobile &&
                <div className="tournaments__lobby__header--mobile__img-wrapper">
                  <img src={`${data.tournamentGames[0]['thumbnail']}`} alt={`${data.tournamentName}`} />
                </div>
              }
              {data.tournamentAward ? renderPrizePool(playerAwardsStructure, showMorePrizesMobile, isMobile, showMorePrizesMobile, chipValue) : false}
              {playerAwardsStructure.length > 3 && <div className="tournaments__lobby__button-prize-wrapper--mobile">
                <button className='tournaments__lobby__stats-prize-button--mobile tertiary' onClick={() => setShowMorePrizesMobile(show => !show)}>
                  <span>{showMorePrizesMobile ? `${t('tournaments.seeLess')}` : `${t('tournaments.seeMore')}`}</span>
                </button>
              </div>}
            </div>}
            {
              tournamentCasinoPlayersList.length ?
                <div className="tournaments__lobby__players-list--mobile">
                  <div className="tournaments__lobby__players-table-wrapper--mobile">
                    <TournamentPlayerList showMorePlayersMobile={showMorePlayersMobile} isMobile={isMobile} playerList={tournamentCasinoPlayersList} />
                  </div>
                  {
                    tournamentCasinoPlayersList.length > 3 &&
                    <div className="tournaments__lobby__button-prize-wrapper--mobile">
                      <button className='tournaments__lobby__stats-prize-button--mobile tertiary' onClick={() => setShowMorePlayersMobile(show => !show)}>
                        <span>{showMorePlayersMobile ? `${t('tournaments.seeLess')}` : `${t('tournaments.seeMore')}`}</span>
                      </button>
                    </div>
                  }
                </div>
                : false
            }
          </div>
        </React.Fragment>
      </div>
    </div>
  );
}

export default TournamentLobby;
